import { useNavigate } from 'react-router-dom';
import { useLoader } from '../../../../components/loader/useLoader';
import { useGlobalConfig } from '../../../../components/globalConfig/GlobalConfigContext';
import { useCheckoutCoreState } from './useCheckoutCoreState';
import { useReserveHouse } from './useReserveHouse';
import { useIsReadyToReserve } from './useIsReadyToReserve';
import { useReservationLoader } from './useReservationLoader';
import { useLoaderContext } from '../../../../components/loader/LoaderContext';

export function useCheckoutState(reservationId, houseId) {
  const navigate = useNavigate();
  const { loader, setLoader } = useLoaderContext();
  const globalConfig = useGlobalConfig();

  const state = useCheckoutCoreState(reservationId, globalConfig);

  useReservationLoader({
    reservationId,
    ...state,
  });

  const reserveHouse = useReserveHouse({
    ...state,
    reservationId,
    houseId,
    navigate,
    setLoader,
  });

  const isReadyToReserve = useIsReadyToReserve(state, reservationId);

  return {
    ...state,
    reserveHouse,
    isReadyToReserve,
    isLoading: state.checkoutStateLoading || state.reservationLoading,
  };
}
